<template>
  <div class='compareClickDialog' @click="clickDialog" id="dialog">
    <div class='bg' :style="{top: top, left: left}">
      <div class="box">
        <div class="top-div">
          <img class="img1" src="@/assets/compare-line.png" />
          <img class="img2" src="@/assets/compare-border.png" />
          <img class="img3" src="@/assets/compare-mouse.png" />
          <img class="img4" src="@/assets/compare-cancel.png" @click="missDo"/>
        </div>
        <img class="img5" src="@/assets/compare-jiantou.png" />
        <section class="bottom-div">
          <div class="content-single">
            <p>单击</p>
            <div class="content">重新排序：以大到小，或以小到大。</div>
          </div>
          <div class="content-double content-single">
            <p>双击</p>
            <div class="content">重新定义优劣：以增加为优，或以减少为优。</div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'compareClickDialog',
  props: {
    top: {
      type: String,
      default: ''
    },
    left: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    missDo() {
      this.$emit("missDo")
    },
    clickDialog(event) {
      console.log("clickDialog === ", event)
      const id = event.target.id
      if (id == 'dialog') {
        this.missDo()
      }
    },
  },
  created() {
    
  }
}
</script>
<style lang='less' scoped>
.compareClickDialog {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 9999;
  top: 0px;
}
.bg {
  width: 540px;
  height: 160px;
  background-color:#fff;
  position: absolute;
  // //536 225 20
  // top: 291px;
  // //900
  // left: 900px;
  opacity: 1;
  border-radius: 10px;
}
.box {
  margin: 0 auto;
  position: relative;
  height: 100%;
}
.top-div {
  position: relative;
  .img1 {
    margin-top: 38px;
    width: 300px;
    height: 6px;
  }
  .img2 {
    position: absolute;
    width: 111px;
    height: 13px;
    top: 34px;
    right: 116px;
  }
  .img3 {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 45px;
    right: 130px;
  }
  .img4 {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 10px;
    right: 38px;
    cursor: pointer;
  }
}
.img5 {
  position: absolute;
  bottom: -20px;
  left: 0px;
  width: 40px;
  height: 40px;
}

.bottom-div {
  padding: 20px 40px 0px 60px;
  .content-single {
    display: flex;
    align-items: center;
    p {
      color: #383838;
      font-size: 12px;
      font-weight: 700;
    }
    .content {
      margin-left: 20px;
      width: 380px;
      height: 35px;
      background-color: #F5F5F5;
      display: flex;
      align-items: center;
      padding-left: 15px;
      font-size: 12px;
      font-weight: 600;
      color: #A6A6A6;
    }
  }
  
  .content-double {
    margin-top: 10px;
  } 

}
 
</style>